/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react"
import * as Sentry from "@sentry/remix"
import { startTransition, StrictMode, useEffect } from "react"
import { hydrateRoot } from "react-dom/client"

Sentry.init({
    dsn: "https://b0d292d166a4695ac4266a804ba39bce@o4506851525984256.ingest.us.sentry.io/4508012274319360",
    // @ts-ignore window.ENV is defined in root.tsx
    environment: window.ENV.SENTRY_ENV,
    // @ts-ignore window.ENV is defined in root.tsx
    release: window.ENV.VERSION,
    // @ts-ignore window.ENV is defined in root.tsx
    enabled: window.ENV.NODE_ENV == "production",
    tracesSampleRate: 0.1,
    integrations: [
        Sentry.browserTracingIntegration({
            useEffect,
            useLocation,
            useMatches,
        }),
        Sentry.replayIntegration(),
    ],
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
})

startTransition(() => {
    hydrateRoot(
        document,
        <StrictMode>
            <RemixBrowser />
        </StrictMode>
    )
})
